import { useContext, useEffect, useRef } from 'react';
import GlobalContext from '../contexts/global.js';
import StateContext from '../contexts/state.js';

/* Forces state.currentLos to a given LoS key while the calling component is mounted, restoring the original value on unmount - unless the user picked a different LoS, in which case their choice is kept. */
/* A late SSO/override preselection (state.userLos change) only replaces the value to restore. */
const useTemporaryLos = (losKey) => {
    const { globalContext } = useContext(GlobalContext);
    const { state, updateState } = useContext(StateContext);

    const originalLosRef = useRef(state.currentLos);
    const targetLosRef = useRef(null);
    const userLosRef = useRef(state.userLos);
    const manuallyChangedRef = useRef(false);

    useEffect(() => {
        const preselected = state.userLos !== userLosRef.current;
        userLosRef.current = state.userLos;
        if(preselected) {
            originalLosRef.current = state.userLos?.length ? state.userLos : [
                globalContext.los[0]
            ];
        }

        if(manuallyChangedRef.current || state.currentLos === targetLosRef.current) {
            return;
        }

        /* Picked in the NavigationSideBar */
        if(targetLosRef.current && !preselected) {
            manuallyChangedRef.current = true;
            return;
        }

        const targetLos = (globalContext?.los || []).filter(({ key }) => key === losKey);
        if(targetLos.length) {
            targetLosRef.current = targetLos;
            updateState({ currentLos: targetLos });
        }
    }, [globalContext?.los, state.userLos, state.currentLos]);

    useEffect(() => () => {
        if(!manuallyChangedRef.current) {
            updateState({ currentLos: originalLosRef.current });
        }
    }, []);
};

export default useTemporaryLos;
